import * as React from 'react';
import useServiceSelector from '~/theseus/hooks/useServiceSelector';
import { AuthSelector } from './selectors';
import { AuthService } from './service';

const AuthContext = React.createContext<null | AuthService>(null);

interface Props {
  service: AuthService;
  children: React.ReactChildren;
}
export function AuthProvider(props: Props) {
  const { service, children } = props;

  return (
    <AuthContext.Provider value={service}>
      { children }
    </AuthContext.Provider>
  );
}

export function useAuthService(): AuthService {
  const service = React.useContext(AuthContext) as AuthService;

  if (!service) {
    throw new Error('`useAuthService` must be wrapped in `AuthProvider`');
  }

  return service;
}

export function useAuthSelector<T>(selector: AuthSelector<T>): T {
  const service = useAuthService();

  return useServiceSelector(service, selector);
}
